import { GroupsFeedLoggedOutScreen } from './groups-feed-logged-out-screen'
import { hotGroupsQuery, useHotGroupsQuery } from './queries'

interface GroupsFeedLoggedOutScreenContainerProps {
  HeaderComponent?: React.ReactNode
}

export const GroupsFeedLoggedOutScreenContainer = ({
  HeaderComponent,
}: GroupsFeedLoggedOutScreenContainerProps) => {
  const { data: hotGroupsData, networkStatus } = useHotGroupsQuery({
    variables: hotGroupsQuery.defaultVariables,
    notifyOnNetworkStatusChange: true,
  })

  const groups = hotGroupsData?.searchGroups?.docs || []
  const groupsLoading = networkStatus === 1

  return (
    <GroupsFeedLoggedOutScreen
      HeaderComponent={HeaderComponent}
      groups={groups}
      groupsLoading={groupsLoading}
    />
  )
}
